import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY, COLORS } from '@sortlist-frontend/design-system/legacy';

export const AgenciesListWrapper = styled.div`
  &:last-child {
    margin-left: 1rem;
    @media only screen and (max-width: ${BREAKPOINTS_LEGACY.sm}) {
      margin-left: 0;
    }
  }
`;

export const Anchor = styled.a`
  :hover {
    color: ${COLORS.PRIMARY_500};
  }
`;
